import React, { useState } from "react";
import useStyles from "./styles";
import { Typography } from "@mui/material";
import ChatIcon from "../../assets/chatAvatar.png";

const ChatWidget = ({ chatUrl }) => {
  const classes = useStyles();
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([
    {
      type: "bot",
      text: "Hi, This is your AI based ESG expert Shibila. How can I help you today",
    },
  ]);
  const [input, setInput] = useState("");

  const toggleChat = () => setIsOpen(!isOpen);

  const sendMessage = async () => {
    if (!input.trim()) return;
    const userInput = input;
    setInput("");
    const userMessage = { type: "user", text: userInput };
    setMessages((prev) => [...prev, userMessage]);

    try {
      const res = await fetch(chatUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ question: userInput }),
      });
      console.log(res, "response");

      const data = await res.json();
      const botMessage = { type: "bot", text: data.answer };
      setMessages((prev) => [...prev, botMessage]);
    } catch (err) {
      setMessages((prev) => [
        ...prev,
        { type: "bot", text: "Error connecting to server." },
      ]);
    }

    setInput("");
  };

  return (
    <>
      <div
        className={isOpen ? classes.chatToggle : classes.glowButton}
        onClick={toggleChat}
      >
        <img src={ChatIcon} height="30" width="30" alt="Logo" />
      </div>
      {isOpen && (
        <div className={classes.chatPopup}>
          <div className={classes.chatHeader}>
            <span>AI Agent Shibila</span>
            <Typography onClick={toggleChat}>×</Typography>
          </div>
          <div className={classes.chatBody}>
            {messages.map((msg, i) => (
              <div
                key={i}
                className={
                  msg.type === "bot" ? classes.chatMsgBot : classes.chatMsgUser
                }
              >
                {msg.text}
              </div>
            ))}
          </div>
          <div className={classes.chatInput}>
            <input
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && sendMessage()}
              placeholder="Ask a question..."
              className={classes.chatInputInput}
            />
            <button className={classes.chatInputButton} onClick={sendMessage}>
              Send
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default ChatWidget;
